function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this;
    var args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    }, wait);
    if (immediate && !timeout) func.apply(context, args);
  };
}

var Autocomplete = function (form, options) {
  if (!(this instanceof Autocomplete)) return new Autocomplete(form, options);
  var _ = this;

  var $window = $(window);
  var $form = $(form);
  var $resultsContainer = $form.find('.destination-autocomplete');
  var $input = $form.find(options.input);
  var input = $input[0];

  var dist = options.dist || 100;
  var lat;
  var lng;

  var service = Vars.googleService;
  var geocoder = Vars.googleGeocoder;
  var countryPass = 0;
  var cities = [];

  if (typeof input !== 'undefined') {
    var autoComplete = horsey(input, {
      suggestions: cities,
      appendTo: $resultsContainer[0],
      debounce: 250,
      render(li, suggestion) {
        $resultsContainer.find('.sey-list').addClass('sey-show');

        var city;
        var country;
        var $item = $(li);

        // Set items size
        setItemsSize(li);

        if (suggestion.indexOf(',') > -1) {
          city = suggestion.split(',')[0];
          country = suggestion.split(',')[1];
          $item.html(`${city}, <span>${country}</span>`);
        } else {
          city = suggestion;
          $item.html(city);
        }
      },
    });

    $input.on({
      'horsey-show': function () {
        // console.log('Autocomplete:horsey-show');
        $body.addClass('header-is-open');
      },
      'horsey-hide': function () {
        // console.log('Autocomplete:horsey-hide');
        $body.removeClass('header-is-open');
      },
      input: debounce(function (e) {
        if (this.value.length) {
          countryPass = 0;

          var c = service.getPlacePredictions(
            {
              input: this.value,
              types: ['(cities)'],
              componentRestrictions: {
                country: 'fr',
              },
            },
            displaySuggestions
          );
        } else {
          cities = [];
          autoComplete.clear();
          autoComplete.hide();
        }
      }, 200),
      'horsey-selected': horseySelectedHandler,
    });
  }

  $window.on('resize', function () {
    setItemsSize('li.sey-item');
  });

  /**
   * Set size of list items
   * @param {string|object} selector The items to find
   */
  function setItemsSize(selector) {
    var $items = $form.find(selector);

    if ($items.length) {
      $items.css({
        left: `${$input.offset().left}px`,
        width: `${$input.outerWidth()}px`,
      });
    }
  }

  /**
   * Append the results
   * @param  {object} predictions The results from Google
   * @param  {string} status      The query status
   * @return {undefined}
   */
  function displaySuggestions(predictions, status) {
    // console.log('Autocomplete:displaySuggestions', predictions);

    if (countryPass === 0) {
      cities = [];
    }
    countryPass += 1;

    if (predictions) {
      var city = '';
      var country = '';
      var { length } = predictions;

      // console.log(predictions)

      while (length--) {
        cities.push(predictions[length].description);
      }
    }

    if (countryPass) {
      var { length } = cities;
      autoComplete.clear();

      while (length--) {
        autoComplete.add(cities[length]);
      }
    }
  }

  function horseySelectedHandler(e) {
    // console.log('Autocomplete:horseySelected');
    var place = e.target.value;
  }

  /**
   * Get coordinates with the geocoder
   * @param  {string} address The adress to find
   * @return {object}         An object with the address' coordinates
   */
  function getCoordinates(address, callback) {
    geocoder.geocode({ address }, function (results, status) {
      if (results.length > 0) {
        var place = results[0];

        var lat = place.geometry.location.lat();
        var lng = place.geometry.location.lng();
        var position = getRadius(lat, lng, dist);

        if (typeof callback === 'function') callback(position);
        return position;
      }
    });
  }

  function getRadius(lat, lng, dist) {
    var latFrom = Utils.getNewLat(lat, -dist);
    var latTo = Utils.getNewLat(lat, dist);
    var lngFrom = Utils.getNewLng(lat, lng, -dist);
    var lngTo = Utils.getNewLng(lat, lng, dist);

    return {
      lat: {
        from: latFrom,
        to: latTo,
        origin: lat,
      },
      lng: {
        from: lngFrom,
        to: lngTo,
        origin: lng,
      },
    };
  }

  _.$form = $form;
  _.$input = $input;
  _.getCoordinates = getCoordinates;
  return _;
};
window.Autocomplete = Autocomplete;
